import { useTranslation } from 'react-i18next';
import React from "react";
import { useStockPoDetailModel } from "../backlogModel";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";

export function PageHeader() {
    const { t } = useTranslation();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStockPoDetailModel();
    const searchFields = [
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.单据编号`),
            fieldName: "bussCode"
        },
        {
            type:'Input',
            placeholder: t(`stock.view.PageHeader.商品编号`),
            fieldName: "materialCode"
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.商品名称`),
            fieldName: "materialName"
        },
        {
            type:'Input',
            placeholder: t(`stock.view.PageHeader.供应商名称`),
            fieldName: "supplierName"
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.替换编号`),
            fieldName: "replaceCode"
        },
        {
            type: 'Input',
            placeholder: t(`stock.view.PageHeader.货位`),
            fieldName: "shelfCode"
        },
    ]


    return (
        <YhPageHeader
            title= {t(`stock.view.PageHeader.积压管理`)}
            size="small"
            justify="end"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageSize: 15, current: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}